module.exports = __webpack_public_path__ + "img/product2.beaee7d8.png";